<div>
	<div class="pt-2">
		<div class="card">
			<div class="card-header">
				Mobile Register
			</div>
			<div class="card-body">
				<div class="row pt-2">
					<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
						class="customeDatatable table table-bordered">
						<thead class="table-light">
							<tr>
								<th>EmpCode</th>
								<th>EmpName</th>
								<th>Branch Name</th>
								<th>CreateBy</th>
								<th style="width: 250px;"
									[ngClass]="{'colHide': !this.common.PageRight.IsEdit || !this.common.PageRight.IsView}">
									Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let element of EmployeeData; let i = index">
								<td>{{element['EmpCode']}}</td>
								<td>{{element['EmpName']}}</td>
								<td>{{element['Branch']}}</td>
								<td>{{element['CreateBy']}}</td>
								<td style="width: 250px;"
									[ngClass]="{'colHide': !this.common.PageRight.IsEdit || !this.common.PageRight.IsView}">
									<div style="width: 250px;">
										<button type="button" class="btn btn-primary btn-sm mx-1"
											[routerLink]="['/onboarding/mobileregister/detail/' + element['ID'] + '/false']"><i
												class="bi bi-eye me-2"></i>View</button>
										<button type="button" class="btn btn-primary btn-sm mx-1"
											[routerLink]="['/onboarding/mobileregister/add/' + element['ID'] + '/false']"><i
												class="bi bi-pencil-square me-2"></i>Edit</button>
										<button type="button" class="btn btn-danger btn-sm mx-1"
											(click)="Reject(element['ID'])"><i
												class="bi bi-trash me-2"></i>Reject</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

			</div>

		</div>
	</div>
</div>